import script from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"

import "./NotFoundView.vue?vue&type=style&index=0&id=7b53718e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b53718e"]])

export default __exports__